const alignAndEngageRoutes = {
  AlignAndEngage: () => `/align-and-engage`,
  AlignAndEngageOverview: () => `/w/okrs/all`,
};

const routes = { ...alignAndEngageRoutes };

export default routes;
